import "./paginaMtto.css"


function PaginaMtto() {
    return <header className="img">
        <img src={require("../assets/Images/paginaMtto.png")} alt='Org' />
    </header>
}

export default PaginaMtto